module.exports = VueDemi;